(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atmosfae-video-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialise = (root) => {
      if (!root || root.dataset.atmosfaeReady === 'true') return;

      root.dataset.atmosfaeReady = 'true';
      root.classList.add('is-preparing');

      const title = root.querySelector('[data-atmosfae-type]');
      const video = root.querySelector('video');
      const pauseButton = root.querySelector('[data-atmosfae-pause]');
      const text = title ? title.textContent.trim() : '';

      if (title && text) {
        title.textContent = '';
        title.setAttribute('aria-label', text);

        Array.from(text).forEach((character, index) => {
          const letter = document.createElement('span');
          letter.className = 'atmosfae-entrance__letter';
          letter.setAttribute('aria-hidden', 'true');
          letter.style.setProperty('--atmosfae-letter-index', index);
          letter.textContent = character === ' ' ? '\u00a0' : character;
          title.appendChild(letter);
        });
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const designMode = Boolean(window.Shopify && window.Shopify.designMode);
      let seen = false;

      try {
        seen = window.sessionStorage.getItem('atmosfaeEntranceSeen') === 'true';
      } catch (error) {
        seen = false;
      }

      window.requestAnimationFrame(() => {
        root.classList.remove('is-preparing');

        if (reducedMotion || (seen && !designMode)) {
          root.classList.add('is-seen');
        } else {
          root.classList.add('is-animating');

          try {
            window.sessionStorage.setItem('atmosfaeEntranceSeen', 'true');
          } catch (error) {
            return;
          }
        }
      });

      if (reducedMotion && video) {
        video.pause();
        root.classList.add('is-paused');
      }

      if (pauseButton && video) {
        pauseButton.addEventListener('click', () => {
          if (video.paused) {
            video.play().catch(() => undefined);
            root.classList.remove('is-paused');
            pauseButton.setAttribute('aria-label', pauseButton.dataset.pauseLabel);
          } else {
            video.pause();
            root.classList.add('is-paused');
            pauseButton.setAttribute('aria-label', pauseButton.dataset.playLabel);
          }
        });
      }
    };

    const initialiseAll = (scope = document) => {
      scope.querySelectorAll('[data-atmosfae-entrance]').forEach(initialise);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseAll());
    } else {
      initialiseAll();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
